/** @format */
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';

import { Milliseconds } from '@toucan/client/global/application';
import { MarketContext } from '@toucan/client/global/market';
import { UserContext } from '@toucan/client/global/user';

import { getIdentityVerification } from '@toucan/client/core/intercom';

export const useIdentityVerification = ({
    enabled = false,
    includeContactInformation = false,
}: {
    enabled: boolean;
    includeContactInformation?: boolean;
}) => {
    const { activeMarket } = useContext(MarketContext);
    const { isLoggedIn, user } = useContext(UserContext);
    const marketCode = activeMarket.code.toLowerCase();

    return useQuery({
        queryKey: [
            'intercom',
            'identity',
            marketCode,
            user?.customerId,
            includeContactInformation ? 'WITH_CONTACT' : 'WITHOUT_CONTACT',
        ],
        queryFn: () =>
            getIdentityVerification(marketCode, includeContactInformation),
        retry: false,
        staleTime: Milliseconds.FIFTEEN_MINUTES,
        cacheTime: 2 * Milliseconds.FIFTEEN_MINUTES,
        refetchOnWindowFocus: false,
        enabled: enabled && isLoggedIn,
    });
};
